"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _Trash = _interopRequireDefault(require("@insided/shared/icons/Trash"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _iconArrowRightV = _interopRequireDefault(require("@insided/legacy-icons/icon-arrow-right-v2"));

var _ssoFieldMappingService = require("@insided/control/modules/EndUserSSO/ssoFieldMappingService");

var _ClockDark = _interopRequireDefault(require("@insided/shared/icons/ClockDark"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _CheckInCircle = _interopRequireDefault(require("@insided/shared/icons/CheckInCircle"));

var _Report = _interopRequireDefault(require("@insided/shared/icons/Report"));

var _zod = require("zod");

var _ConfigurationError = require("@insided/shared/services/ConfigurationError");

var _ConfirmModal = _interopRequireDefault(require("./ConfirmModal"));

var _utils = require("./utils");

var _excluded = ["lastSyncJobId"],
    _excluded2 = ["id", "lastSyncStatus", "lastSyncCompletedAt"],
    _excluded3 = ["lastSyncJobId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isThrownAxiosError(err) {
  return (0, _typeof2.default)(err) === 'object' && err !== null && 'response' in err;
}

var SYNC_STATUS_ICON_PX = 20;
var NO_CC_FIELDS_ITEM = [{
  title: 'No fields available',
  onClick: function onClick() {}
}];
var NO_CS_ATTRS_ITEM = [{
  title: 'No attributes available',
  onClick: function onClick() {}
}];

var CsMappingFieldItemSchema = _zod.z.object({
  sourceObject: _zod.z.string(),
  sourceField: _zod.z.string(),
  targetField: _zod.z.string(),
  dataType: _zod.z.string(),
  updatedAt: _zod.z.string()
}).strict();

var ResponseSchema = _zod.z.object({
  result: _zod.z.boolean(),
  errorCode: _zod.z.string().nullable(),
  errorDesc: _zod.z.string().nullable(),
  requestId: _zod.z.string().nullable()
}).strict();

var BidirectionalMappingSaveResponseSchema = ResponseSchema.extend({
  data: _zod.z.object({
    communityId: _zod.z.string().nullable(),
    csMappingFields: _zod.z.array(CsMappingFieldItemSchema)
  }).strict()
}).strict();

function renderSyncStatus(status) {
  switch (status) {
    case _utils.CSObjectSyncStatus.PENDING:
      return (0, _preact.h)(_ClockDark.default, {
        width: SYNC_STATUS_ICON_PX,
        height: SYNC_STATUS_ICON_PX,
        fill: "#6B707E"
      });

    case _utils.CSObjectSyncStatus.SUCCESS:
      return (0, _preact.h)(_CheckInCircle.default, {
        width: SYNC_STATUS_ICON_PX,
        height: SYNC_STATUS_ICON_PX,
        fill: "#13ad68"
      });

    case _utils.CSObjectSyncStatus.FAILED:
      return (0, _preact.h)(_Report.default, {
        width: SYNC_STATUS_ICON_PX,
        height: SYNC_STATUS_ICON_PX,
        fill: "#dc3626"
      });

    case _utils.CSObjectSyncStatus.PARTIAL_SUCCESS:
      return (0, _preact.h)(_CheckInCircle.default, {
        width: SYNC_STATUS_ICON_PX,
        height: SYNC_STATUS_ICON_PX,
        fill: "#df8404"
      });

    default:
      return null;
  }
}

var UserFieldsMapping = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UserFieldsMapping, _Component);

  var _super = _createSuper(UserFieldsMapping);

  function UserFieldsMapping(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserFieldsMapping);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isMounted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "csObjectByName", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "csObjectOptions", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateDropdownListDirection", function (key, anchor) {
      if (!anchor || !(anchor instanceof HTMLElement)) {
        return;
      }

      var displayUp = (0, _utils.shouldDisplayDropdownListUpwards)(anchor);

      _this.setState(function (prev) {
        return {
          dropdownListUpwards: _objectSpread(_objectSpread({}, prev.dropdownListUpwards), {}, (0, _defineProperty2.default)({}, key, displayUp))
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchExportCsvLink", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(jobId) {
        var res, _err$response$data$er, _err$response, _err$response$data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _axios.default.get("/integration/gainsight-connector/demographics/export?jobId=".concat(jobId));

              case 3:
                res = _context.sent;

                if (_this._isMounted) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", null);

              case 6:
                return _context.abrupt("return", res.data.data.url);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                if (_this._isMounted) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", null);

              case 13:
                _this.handleError(isThrownAxiosError(_context.t0) ? (_err$response$data$er = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errorDesc) !== null && _err$response$data$er !== void 0 ? _err$response$data$er : 'Unable to fetch export CSV link.' : 'Unable to fetch export CSV link.');

                return _context.abrupt("return", null);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleError", function (message) {
      _this.setState({
        messageType: 'error',
        message: message
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "feedbackFromMappingSaveResponse", function (data) {
      if (data.result) {
        _this.setState(function (prev) {
          var _prev$csObjectSyncSta = prev.csObjectSyncStatus,
              lastSyncJobId = _prev$csObjectSyncSta.lastSyncJobId,
              syncStatus = (0, _objectWithoutProperties2.default)(_prev$csObjectSyncSta, _excluded);
          var mappings = (0, _utils.mappingRowsFromBootstrap)(data.data.csMappingFields, syncStatus);
          return {
            messageType: 'success',
            message: 'Field mapping saved successfully',
            mappings: mappings,
            baselineMappingFields: mappings.map(function (m) {
              return _objectSpread({}, m);
            })
          };
        });
      } else {
        _this.handleError(data.errorDesc ? String(data.errorDesc) : 'Unable to save mappings');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleAddMapping", function () {
      _this.setState(function (prev) {
        return {
          mappings: [].concat((0, _toConsumableArray2.default)(prev.mappings), [(0, _utils.createEmptyMapping)((0, _utils.nextId)())])
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRemoveMapping", function (id) {
      _this.setState(function (prev) {
        return {
          mappings: prev.mappings.filter(function (m) {
            return m.id !== id;
          }),
          deleteMappingId: null,
          showConfirmModal: false
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateMapping", function (id, updater) {
      _this.setState(function (prev) {
        return {
          mappings: prev.mappings.map(function (mapping) {
            if (mapping.id !== id) {
              return mapping;
            }

            var next = updater(mapping);
            var baselineMapping = prev.baselineMappingFields.find(function (m) {
              return (0, _utils.mappingRowFingerprint)(m) === (0, _utils.mappingRowFingerprint)(next);
            });

            if (baselineMapping) {
              return baselineMapping;
            }

            return _objectSpread(_objectSpread({}, next), {}, {
              lastSyncStatus: _utils.CSObjectSyncStatus.PENDING,
              updatedAt: new Date().toISOString()
            });
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCsObjectChange", function (id, value) {
      _this.updateMapping(id, function (mapping) {
        if (mapping.sourceObject === value) return mapping;
        return _objectSpread(_objectSpread({}, mapping), {}, {
          sourceObject: value,
          sourceField: '',
          dataType: ''
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCsAttributeChange", function (id, value, dataType) {
      _this.updateMapping(id, function (mapping) {
        return _objectSpread(_objectSpread({}, mapping), {}, {
          sourceField: value,
          dataType: dataType
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCcFieldChange", function (id, value) {
      _this.updateMapping(id, function (mapping) {
        return _objectSpread(_objectSpread({}, mapping), {}, {
          targetField: value
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSave", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var mappings, incomplete, res, parsed, _err$response$data$er2, _err$response2, _err$response2$data, message;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              mappings = _this.state.mappings;
              incomplete = mappings.some(function (m) {
                return (0, _utils.isBlank)(m.sourceObject) || (0, _utils.isBlank)(m.sourceField) || (0, _utils.isBlank)(m.targetField);
              });

              if (!incomplete) {
                _context2.next = 5;
                break;
              }

              _this.handleError('Please complete all field mappings before saving.');

              return _context2.abrupt("return");

            case 5:
              _this.setState({
                isSaving: true
              });

              _context2.prev = 6;
              _context2.next = 9;
              return _axios.default.put('/integration/gainsight-connector/mappings', {
                csMappingFields: mappings.map(function (_ref3) {
                  var id = _ref3.id,
                      lastSyncStatus = _ref3.lastSyncStatus,
                      lastSyncCompletedAt = _ref3.lastSyncCompletedAt,
                      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
                  return rest;
                })
              });

            case 9:
              res = _context2.sent;
              parsed = BidirectionalMappingSaveResponseSchema.safeParse(res.data);

              if (parsed.success) {
                _context2.next = 14;
                break;
              }

              _this.setState({
                configError: parsed.error
              });

              return _context2.abrupt("return");

            case 14:
              _this.feedbackFromMappingSaveResponse(parsed.data);

              _context2.next = 21;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](6);
              message = isThrownAxiosError(_context2.t0) ? (_err$response$data$er2 = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.errorDesc) !== null && _err$response$data$er2 !== void 0 ? _err$response$data$er2 : 'Unable to save mappings' : 'Unable to save mappings';

              _this.handleError(message);

            case 21:
              _context2.prev = 21;

              _this.setState({
                isSaving: false
              });

              return _context2.finish(21);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 17, 21, 24]]);
    })));
    _this.csObjectByName = new Map();
    _this.csObjectOptions = [];
    /* eslint-disable-next-line react/state-in-constructor */

    _this.state = {
      mappings: [],
      ccFields: [],
      gainsightConnectorEnabled: false,
      configError: null,
      message: null,
      messageType: null,
      csObjectSyncStatus: {
        lastSyncStatus: _utils.CSObjectSyncStatus.PENDING,
        lastSyncCompletedAt: null,
        lastSyncJobId: null
      },
      deleteMappingId: null,
      baselineMappingFields: [],
      dropdownListUpwards: {},
      isSaving: false,
      showConfirmModal: false
    };
    return _this;
  }

  (0, _createClass2.default)(UserFieldsMapping, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _syncRes$data$data, _syncData$lastSyncSta, _syncData$lastSyncSta2, _syncData$lastSyncJob, _metadataRes$data$dat, _mappingRes$data$data, _mappingRes$data$data2, _settingsRes$data$dat, _settingsRes$data$dat2, _yield$Promise$all, _yield$Promise$all2, settingsRes, mappingRes, syncRes, profileFields, metadataRes, ccFields, syncData, lastSyncCompletedAt, csObjectSyncStatus, csObjects, lastSyncJobId, syncStatus, fields, mappings, gainsightConnectorEnabled, _err$response$data$er3, _err$response3, _err$response3$data;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._isMounted = true;
                _context3.prev = 1;
                _context3.next = 4;
                return Promise.all([_axios.default.get('/integration/gainsight-connector/settings'), _axios.default.get('/integration/gainsight-connector/mapping/details'), _axios.default.get('/integration/gainsight-connector/syncStatus'), (0, _ssoFieldMappingService.fetchCCFields)(), _axios.default.post('/integration/gainsight-connector/object/metadata', {
                  objectNames: ['person', 'company_person']
                })]);

              case 4:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 5);
                settingsRes = _yield$Promise$all2[0];
                mappingRes = _yield$Promise$all2[1];
                syncRes = _yield$Promise$all2[2];
                profileFields = _yield$Promise$all2[3].profileFields;
                metadataRes = _yield$Promise$all2[4];

                if (this._isMounted) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("return");

              case 13:
                ccFields = profileFields.map(function (field) {
                  return {
                    value: field.title,
                    label: field.title
                  };
                });
                syncData = (_syncRes$data$data = syncRes.data.data) !== null && _syncRes$data$data !== void 0 ? _syncRes$data$data : {
                  lastSyncStatus: 'PENDING',
                  lastSyncCompletedAt: null,
                  jobId: null
                };
                lastSyncCompletedAt = syncData.lastSyncCompletedAt ? (0, _utils.parseDateTimeAsUTC)(syncData.lastSyncCompletedAt) : null;
                csObjectSyncStatus = {
                  lastSyncStatus: (_syncData$lastSyncSta = (_syncData$lastSyncSta2 = syncData.lastSyncStatus) === null || _syncData$lastSyncSta2 === void 0 ? void 0 : _syncData$lastSyncSta2.toUpperCase()) !== null && _syncData$lastSyncSta !== void 0 ? _syncData$lastSyncSta : 'PENDING',
                  lastSyncCompletedAt: lastSyncCompletedAt,
                  lastSyncJobId: (_syncData$lastSyncJob = syncData.lastSyncJobId) !== null && _syncData$lastSyncJob !== void 0 ? _syncData$lastSyncJob : null
                };
                csObjects = (_metadataRes$data$dat = metadataRes.data.data) !== null && _metadataRes$data$dat !== void 0 ? _metadataRes$data$dat : [];
                this.csObjectByName = new Map(csObjects.map(function (o) {
                  return [o.objectName, o];
                }));
                this.csObjectOptions = csObjects.map(function (_ref4) {
                  var objectName = _ref4.objectName,
                      label = _ref4.label;
                  return {
                    title: label,
                    value: objectName
                  };
                });
                lastSyncJobId = csObjectSyncStatus.lastSyncJobId, syncStatus = (0, _objectWithoutProperties2.default)(csObjectSyncStatus, _excluded3);
                fields = (_mappingRes$data$data = (_mappingRes$data$data2 = mappingRes.data.data) === null || _mappingRes$data$data2 === void 0 ? void 0 : _mappingRes$data$data2.csMappingFields) !== null && _mappingRes$data$data !== void 0 ? _mappingRes$data$data : [];
                mappings = fields.length > 0 ? (0, _utils.mappingRowsFromBootstrap)(fields, syncStatus) : [];
                gainsightConnectorEnabled = (_settingsRes$data$dat = (_settingsRes$data$dat2 = settingsRes.data.data) === null || _settingsRes$data$dat2 === void 0 ? void 0 : _settingsRes$data$dat2.isEnabled) !== null && _settingsRes$data$dat !== void 0 ? _settingsRes$data$dat : false;
                this.setState({
                  ccFields: ccFields,
                  csObjectSyncStatus: csObjectSyncStatus,
                  mappings: mappings,
                  baselineMappingFields: mappings.map(function (m) {
                    return _objectSpread({}, m);
                  }),
                  gainsightConnectorEnabled: gainsightConnectorEnabled
                });
                _context3.next = 32;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t0 = _context3["catch"](1);

                if (this._isMounted) {
                  _context3.next = 31;
                  break;
                }

                return _context3.abrupt("return");

              case 31:
                this.handleError(isThrownAxiosError(_context3.t0) ? (_err$response$data$er3 = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : _err$response3$data.errorDesc) !== null && _err$response$data$er3 !== void 0 ? _err$response$data$er3 : 'Unable to load mapping data.' : 'Unable to load mapping data.');

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 27]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "isSaveDisabled",
    value: function isSaveDisabled(mappings) {
      return (0, _utils.mappingsMatchBaseline)(mappings, this.state.baselineMappingFields);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          mappings = _this$state.mappings,
          ccFields = _this$state.ccFields,
          gainsightConnectorEnabled = _this$state.gainsightConnectorEnabled,
          messageType = _this$state.messageType,
          message = _this$state.message,
          configError = _this$state.configError,
          csObjectSyncStatus = _this$state.csObjectSyncStatus,
          deleteMappingId = _this$state.deleteMappingId,
          isSaving = _this$state.isSaving,
          showConfirmModal = _this$state.showConfirmModal;
      var alertVisibleFor = messageType ? 5000 : false;

      if (!gainsightConnectorEnabled) {
        return null;
      }

      if (configError) {
        return (0, _preact.h)(_ConfigurationError.ConfigurationError, {
          error: configError
        });
      }

      var csObjectByName = this.csObjectByName,
          csObjectOptions = this.csObjectOptions;
      var ccFieldByValue = new Map(ccFields.map(function (field) {
        return [field.value, field.label];
      }));
      var ccFieldItems = ccFields.map(function (_ref5) {
        var title = _ref5.label,
            value = _ref5.value;
        return {
          title: title,
          value: value
        };
      });

      var csAttributesForObject = function csAttributesForObject(csObjectName) {
        var _csObjectByName$get$f, _csObjectByName$get;

        return (_csObjectByName$get$f = (_csObjectByName$get = csObjectByName.get(csObjectName)) === null || _csObjectByName$get === void 0 ? void 0 : _csObjectByName$get.fields.map(function (_ref6) {
          var fieldName = _ref6.fieldName,
              label = _ref6.label,
              dataType = _ref6.dataType;
          return {
            title: label,
            value: fieldName,
            dataType: dataType
          };
        })) !== null && _csObjectByName$get$f !== void 0 ? _csObjectByName$get$f : [];
      };

      var _allTakenFieldSets = (0, _utils.allTakenFieldSets)(mappings),
          takenTargetFields = _allTakenFieldSets.takenTargetFields,
          takenCsAttributes = _allTakenFieldSets.takenCsAttributes;

      var confirmModalProps = null;

      if (showConfirmModal && deleteMappingId) {
        confirmModalProps = {
          title: 'Remove field mapping',
          description: 'This CS field will stop syncing to Community. Existing profile data will remain, but will no longer be updated.',
          confirmTitle: 'Remove',
          confirmVariant: 'warning',
          onConfirm: function onConfirm() {
            return _this2.handleRemoveMapping(deleteMappingId);
          },
          onClose: function onClose() {
            return _this2.setState({
              showConfirmModal: false,
              deleteMappingId: null
            });
          }
        };
      } else if (showConfirmModal) {
        confirmModalProps = {
          title: 'Export to CSV',
          description: 'Export the most recently synced data from Gainsight CS as a CSV file.',
          confirmTitle: 'Export',
          confirmVariant: 'primary',
          onConfirm: function onConfirm() {
            var lastSyncJobId = csObjectSyncStatus.lastSyncJobId;

            if (lastSyncJobId) {
              void _this2.fetchExportCsvLink(lastSyncJobId).then(function (url) {
                if (url) window.open(url, '_blank');
              });
            }

            _this2.setState({
              showConfirmModal: false
            });
          },
          onClose: function onClose() {
            return _this2.setState({
              showConfirmModal: false
            });
          }
        };
      }

      return (0, _preact.h)("div", {
        className: "user-fields-mapping"
      }, confirmModalProps && (0, _preact.h)(_ConfirmModal.default, (0, _extends2.default)({
        isLoading: false
      }, confirmModalProps)), messageType ? (0, _preact.h)(_AlertComponent.default, {
        sticky: true,
        messageType: messageType,
        message: message,
        isVisibleFor: alertVisibleFor,
        onTimeoutEnd: function onTimeoutEnd() {
          return _this2.setState({
            messageType: null,
            message: null
          });
        },
        showIcon: true
      }) : null, (0, _preact.h)("div", {
        className: "control-header"
      }, (0, _preact.h)("h2", {
        className: "control-header__title"
      }, "User Profile Fields Mapping"), (0, _preact.h)("div", {
        className: "control-header__controls"
      }, csObjectSyncStatus.lastSyncJobId && (0, _preact.h)(_Button.default, {
        title: "Export to CSV",
        variant: "secondary",
        size: "medium",
        onClick: function onClick() {
          return _this2.setState({
            showConfirmModal: true
          });
        },
        className: "user-fields-mapping__download-btn",
        "data-element-name": "Export to CSV"
      }), (0, _preact.h)(_Button.default, {
        title: "Save changes",
        variant: "primary",
        size: "medium",
        onClick: this.handleSave,
        disabled: this.isSaveDisabled(mappings) || isSaving,
        className: "user-fields-mapping__save-btn",
        "data-element-name": "Save changes button"
      }))), (0, _preact.h)("h3", {
        className: "user-fields-mapping__title"
      }, "Bring CS data into your Community"), (0, _preact.h)("p", {
        className: "user-fields-mapping__description"
      }, "Pull Gainsight CS data into Community user profiles to power personalized experiences. Mapped fields sync automatically every 4 hours."), mappings.length > 0 && (0, _preact.h)("div", null, (0, _preact.h)("table", {
        className: "table user-fields-mapping__table"
      }, (0, _preact.h)("thead", null, (0, _preact.h)("tr", null, (0, _preact.h)("th", null, "CS Object"), (0, _preact.h)("th", null, "CS Attribute"), (0, _preact.h)("th", null, (0, _preact.h)("span", {
        className: "sr-only"
      }, "Mapping direction")), (0, _preact.h)("th", null, "CC User Profile Field"), (0, _preact.h)("th", {
        style: {
          textAlign: 'center'
        }
      }, "Status"), (0, _preact.h)("th", null, (0, _preact.h)("span", {
        className: "sr-only"
      }, "Actions")))), (0, _preact.h)("tbody", null, mappings.map(function (row) {
        var _selectedObject$label, _selectedObject$field, _selectedObject$field2, _ccFieldByValue$get;

        var selectedObject = csObjectByName.get(row.sourceObject);
        var selectedObjectLabel = (_selectedObject$label = selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.label) !== null && _selectedObject$label !== void 0 ? _selectedObject$label : '';
        var selectedAttributeLabel = (_selectedObject$field = selectedObject === null || selectedObject === void 0 ? void 0 : (_selectedObject$field2 = selectedObject.fields.find(function (_ref7) {
          var fieldName = _ref7.fieldName;
          return fieldName === row.sourceField;
        })) === null || _selectedObject$field2 === void 0 ? void 0 : _selectedObject$field2.label) !== null && _selectedObject$field !== void 0 ? _selectedObject$field : '';
        var syncStatusTooltip = (0, _utils.syncStatusTooltipMessage)(row.lastSyncStatus, row.lastSyncCompletedAt);
        var statusIcon = renderSyncStatus(row.lastSyncStatus);

        var _rowListSelections = (0, _utils.rowListSelections)(row, takenTargetFields, takenCsAttributes, ccFieldItems, ccFieldByValue, csAttributesForObject),
            ccOptionsForRow = _rowListSelections.ccOptionsForRow,
            csAttrsForRow = _rowListSelections.csAttrsForRow;

        var ccDropdownItems = ccFieldItems.length > 0 && ccOptionsForRow.length > 0 ? ccOptionsForRow.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            onClick: function onClick() {
              var _item$value;

              return _this2.handleCcFieldChange(row.id, (_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : item.title);
            }
          });
        }) : NO_CC_FIELDS_ITEM;
        var dropdownKeyObject = "".concat(row.id, ":object");
        var dropdownKeyAttribute = "".concat(row.id, ":attribute");
        var dropdownKeyCc = "".concat(row.id, ":cc");
        return (0, _preact.h)("tr", {
          key: row.id
        }, (0, _preact.h)("td", {
          className: "user-fields-mapping__cell"
        }, (0, _preact.h)("div", {
          className: "user-fields-mapping__dropdown-anchor",
          onClickCapture: function onClickCapture(e) {
            return _this2.updateDropdownListDirection(dropdownKeyObject, e.currentTarget);
          }
        }, (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "adjust",
          displayListUpwards: !!_this2.state.dropdownListUpwards[dropdownKeyObject],
          triggerClass: "user-fields-mapping__dropdown-trigger",
          items: csObjectOptions.map(function (obj) {
            return {
              title: (0, _utils.objectLabelForDisplay)(obj.title),
              onClick: function onClick() {
                return _this2.handleCsObjectChange(row.id, obj.value);
              }
            };
          }),
          trigger: (0, _preact.h)(_Button.default, {
            title: selectedObjectLabel === '' ? 'Select object' : (0, _utils.objectLabelForDisplay)(selectedObjectLabel),
            endIcon: (0, _preact.h)(_ChevronDown.default, {
              width: 16,
              height: 16,
              fill: "#9599A2"
            }),
            size: "medium",
            className: (0, _classnames.default)('user-fields-mapping__select-btn', {
              'user-fields-mapping__select-btn--placeholder': !row.sourceObject
            })
          })
        }))), (0, _preact.h)("td", {
          className: "user-fields-mapping__cell"
        }, (0, _preact.h)("div", {
          className: "user-fields-mapping__dropdown-anchor",
          onClickCapture: function onClickCapture(e) {
            return _this2.updateDropdownListDirection(dropdownKeyAttribute, e.currentTarget);
          }
        }, (0, _preact.h)(_DropdownControl.default, {
          className: "user-fields-mapping__dropdown-control",
          closeOnDropdownClick: true,
          align: "adjust",
          displayListUpwards: !!_this2.state.dropdownListUpwards[dropdownKeyAttribute],
          hasSearch: true,
          searchPlaceholderText: "Search...",
          triggerClass: "user-fields-mapping__dropdown-trigger",
          items: csAttrsForRow.length > 0 ? csAttrsForRow.map(function (attr) {
            return {
              title: attr.title,
              onClick: function onClick() {
                return _this2.handleCsAttributeChange(row.id, attr.value, attr.dataType);
              }
            };
          }) : NO_CS_ATTRS_ITEM,
          disabled: !row.sourceObject,
          trigger: (0, _preact.h)(_Button.default, {
            title: selectedAttributeLabel === '' ? 'Select attribute' : selectedAttributeLabel,
            endIcon: (0, _preact.h)(_ChevronDown.default, {
              width: 16,
              height: 16,
              fill: "#9599A2"
            }),
            size: "medium",
            className: (0, _classnames.default)('user-fields-mapping__select-btn', {
              'user-fields-mapping__select-btn--disabled': !row.sourceObject,
              'user-fields-mapping__select-btn--placeholder': !row.sourceField
            })
          })
        }))), (0, _preact.h)("td", {
          className: "user-fields-mapping__cell user-fields-mapping__cell--arrow"
        }, (0, _preact.h)(_iconArrowRightV.default, {
          width: 18,
          height: 18,
          color: "#2B3346"
        })), (0, _preact.h)("td", {
          className: "user-fields-mapping__cell"
        }, (0, _preact.h)("div", {
          className: "user-fields-mapping__dropdown-anchor",
          onClickCapture: function onClickCapture(e) {
            return _this2.updateDropdownListDirection(dropdownKeyCc, e.currentTarget);
          }
        }, (0, _preact.h)(_DropdownControl.default, {
          className: "user-fields-mapping__dropdown-control",
          closeOnDropdownClick: true,
          align: "adjust",
          displayListUpwards: !!_this2.state.dropdownListUpwards[dropdownKeyCc],
          hasSearch: true,
          searchPlaceholderText: "Search...",
          triggerClass: "user-fields-mapping__dropdown-trigger",
          items: ccDropdownItems,
          trigger: (0, _preact.h)(_Button.default, {
            title: row.targetField ? // targetField from API should match CCFieldOption.value / SSO ids — confirm with API owners.
            (_ccFieldByValue$get = ccFieldByValue.get(row.targetField)) !== null && _ccFieldByValue$get !== void 0 ? _ccFieldByValue$get : row.targetField : 'Select field',
            endIcon: (0, _preact.h)(_ChevronDown.default, {
              width: 16,
              height: 16,
              fill: "#9599A2"
            }),
            size: "medium",
            className: (0, _classnames.default)('user-fields-mapping__select-btn', {
              'user-fields-mapping__select-btn--placeholder': !row.targetField
            })
          })
        }))), (0, _preact.h)("td", {
          className: "user-fields-mapping__cell user-fields-mapping__cell--status"
        }, syncStatusTooltip ? (0, _preact.h)(_Tooltip.default, {
          position: "center",
          verticalPosition: "top",
          noWrap: true,
          trigger: (0, _preact.h)("span", {
            className: "user-fields-mapping__icon-btn user-fields-mapping__icon-btn--muted",
            "aria-label": syncStatusTooltip
          }, statusIcon),
          tooltipMessage: syncStatusTooltip
        }) : (0, _preact.h)("span", {
          className: "user-fields-mapping__icon-btn user-fields-mapping__icon-btn--muted"
        }, statusIcon)), (0, _preact.h)("td", {
          className: "user-fields-mapping__cell"
        }, (0, _preact.h)(_Tooltip.default, {
          position: "center",
          verticalPosition: "top",
          noWrap: true,
          trigger: (0, _preact.h)("button", {
            type: "button",
            className: "user-fields-mapping__icon-btn user-fields-mapping__icon-btn--delete",
            onClick: function onClick() {
              return _this2.setState({
                showConfirmModal: true,
                deleteMappingId: row.id
              });
            },
            "aria-label": "Remove field mapping"
          }, (0, _preact.h)(_Trash.default, {
            width: 18,
            height: 18,
            fill: "#6B707E"
          })),
          tooltipMessage: "Remove"
        })));
      })))), (0, _preact.h)("div", null, (0, _preact.h)("button", {
        type: "button",
        className: "user-fields-mapping__add-mapping-btn",
        onClick: this.handleAddMapping
      }, (0, _preact.h)(_assets.default, {
        icon: "add",
        width: 16,
        height: 16,
        color: "#0369E9"
      }), (0, _preact.h)("span", null, "Add mapping"))));
    }
  }]);
  return UserFieldsMapping;
}(_preact.Component);

exports.default = UserFieldsMapping;